<template>
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 12 17" fill="none">
<path d="M10 7L4.5 12.5L2 10" stroke="#1ED1AC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>